export const getControlsSegment = ({ spaces, colors }) => ({
  segmentContentHighlighted: {
    bg: colors.lightgray[130],
  },
})
